export default "__VITE_ASSET__57ffe73e__"